export default function Aba({ ativa, onClick, icone, texto, badge }) {
	return (
		<button
			onClick={onClick}
			type="button"
			className={`py-2 px-4 font-semibold text-sm rounded-lg flex items-center gap-2 transition-all duration-200 ${
				ativa
					? "bg-white text-customBlue-primary shadow-sm border border-gray-200/80"
					: "text-gray-600 hover:text-gray-900 hover:bg-gray-200/60 border border-transparent"
			}`}
		>
			<span className={ativa ? "text-customBlue-primary" : "text-gray-400"}>{icone}</span>
			<span>{texto}</span>
			{badge !== undefined && (
				<span
					className={`ml-1 px-2 py-0.5 rounded-full text-xs font-bold transition-colors ${
						ativa ? "bg-customBlue-primary/10 text-customBlue-primary" : "bg-gray-200 text-gray-600"
					}`}
				>
					{badge}
				</span>
			)}
		</button>
	);
}
